import { FunctionComponent, ReactNode } from 'react'
import { Flyout } from '~/components/Flyout'

type PureAdmIdentityModuleHelpFlyoutProps = {
  customCheckText: ReactNode
}

const HELP_TEXT_CLASSES =
  'flex flex-col gap-6 [&_code]:select-all [&_code]:rounded [&_code]:bg-(--color-platinum) [&_code]:px-2 [&_code]:py-px [&_h2]:mb-3 [&_ol]:m-0 [&_ol]:ml-5 [&_ol]:p-0 [&_ul]:m-0 [&_ul]:ml-5 [&_ul]:p-0'

export const PureAdmPrebidModuleHelpFlyout: FunctionComponent<PureAdmIdentityModuleHelpFlyoutProps> = ({ customCheckText }) => (
  <Flyout.Content>
    <Flyout.Title>Help</Flyout.Title>
    <Flyout.Body>
      <div className={HELP_TEXT_CLASSES}>
        <div>
          <h2>How can I integrate a Prebid module to my site?</h2>
          <ol>
            <li>Select your site from the list to expand it.</li>
            <li>Fill the required params in the form.</li>
            <li>Validate your information.</li>
            <li>Apply the changes to use the module in production.</li>
          </ol>
        </div>

        <div>
          <h2>How can I manage specific configuration?</h2>
          <p>If you need to go further in module integration, you can click on Edit JSON and fill all optional parameters you might use.</p>
        </div>

        <div>
          <h2>Where can I find the module information?</h2>
          <ul>
            <li>Consult corresponding documentation on modules provider’s website.</li>
            <li>Contact directly your account manager’s partner or support.</li>
          </ul>
        </div>

        <div>
          <h2>How to ensure the module is well set on my site?</h2>
          {/* `kleanadsPbjs` and not the media's own variable: this page is One's, and One serves its own Prebid
              build under that name with the variable locked. */}
          <p>
            You can visit your site and press F12 to open the browser dev tools. In console tab, type <code>kleanadsPbjs.getConfig()</code> and press enter.
          </p>
          <p>Check in {customCheckText} to display the list of module configurations.</p>
        </div>
      </div>
    </Flyout.Body>
  </Flyout.Content>
)
